import React from 'react';
import { connect } from 'react-redux';
import ListItem from 'components/ListItem';
import { createStructuredSelector } from 'reselect';
import { AppState } from 'services/types';
import { ProductId, ProductName } from 'services/products/types';
import { makeSelectProductFieldValue } from 'services/products/selectors';

export interface OwnProps {
    productId: ProductId;
}

export interface ConnectedProps {
    name: ProductName;
}

type Props = OwnProps & ConnectedProps;

export class SummaryProductNameListItemComponent extends React.PureComponent<
    Props
> {
    render(): React.ReactElement {
        const { name } = this.props;

        return <ListItem description="Product" value={name} />;
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    name: makeSelectProductFieldValue('name')
});

export default connect(mapStateToProps)(SummaryProductNameListItemComponent);
